import { Routes } from '@angular/router';
import { ReadComponent } from './read/read.component'; // Display new applications
import { UnderwritingdashboardComponent } from './Dashboard/ZOHO/underwritingdashboard/underwritingdashboard.component';
import { NlsdashboardComponent } from './Dashboard/NLS/funded/current/nlsdashboard/nlsdashboard.component';
import { NlsagencyfundedComponent } from './Dashboard/NLS/funded/monthly/nlsagencyfunded/nlsagencyfunded.component';
import { NlsagencycollectorsComponent } from './Dashboard/NLS/funded/monthly/nlsagencycollectors/nlsagencycollectors.component';
import { LoginComponent } from './login/login.component';
import { authGuard } from './services/auth/auth.guard';
import { unauthGuard } from './services/auth/unauth.guard';
import { HomeComponent } from './home/home.component';
import { UnderwritingagencyexceptionComponent } from './Dashboard/ZOHO/underwritingagencyexception/underwritingagencyexception.component';
import { NlsagencycollectionsComponent } from './Dashboard/NLS/collections/grouped/nlsagencycollections/nlsagencycollections.component';
import { NlsagencycollectionscollectorComponent } from './Dashboard/NLS/collections/grouped/nlsagencycollectionscollector/nlsagencycollectionscollector.component';
import { NlsagencycollectionscollectorclientsComponent } from './Dashboard/NLS/collections/grouped/nlsagencycollectionscollectorclients/nlsagencycollectionscollectorclients.component';
import { NlscreditorcollectionsComponent } from './Dashboard/NLS/collections/grouped/nlscreditorcollections/nlscreditorcollections.component';
import { NlscreditorcollectionscollectorComponent } from './Dashboard/NLS/collections/grouped/nlscreditorcollectionscollector/nlscreditorcollectionscollector.component';
import { ViewUnderwritingComponent } from './view-underwriting/view-underwriting.component';
import { InterviewerqueueComponent } from './Dashboard/ZOHO/interviewerqueue/interviewerqueue.component';
import { ValidatorqueueComponent } from './Dashboard/ZOHO/validatorqueue/validatorqueue.component';
import { MonthlyincomecalcComponent } from './monthlyincomecalc/monthlyincomecalc.component';
import { ApplicationComponent } from './application/application.component';
import { LoanMetaComponent } from './loan-meta/loan-meta.component';
import { PtpReportComponent } from './Dashboard/NLS/ptp-report/ptp-report.component';
import { PtpCreatedReportComponent } from './Dashboard/NLS/ptp-created-report/ptp-created-report.component';
import { UwPerformanceComponent } from './Dashboard/NLS/uw-performance/uw-performance.component';
import { UwDailyStatComponent } from './Dashboard/uw-daily-stat/uw-daily-stat.component';
import { ReportsComponent } from './Dashboard/NLS/reports/reports.component';
import { IntermediaCallReportsComponent } from './tv-custom-dashboards/intermedia-call-reports/intermedia-call-reports.component';
import { CollectionTvReportComponent } from './tv-custom-dashboards/collection-tv-report/collection-tv-report.component';
import { FundedTvReportComponent } from './tv-custom-dashboards/funded-tv-report/funded-tv-report.component';

// Summary
import { SummaryComponent } from './summary/summary.component';
import { ChecklistComponent } from './summary/checklist/checklist.component';
import { UnderwritingComponent } from './summary/underwriting/underwriting.component';
import { LoancalculatorComponent } from './summary/loancalculator/loancalculator.component';
import { TransunionComponent } from './summary/transunion/transunion.component';
import { LoanInterviewComponent } from './summary/loan-interview/loan-interview.component';
import { UnderwritingExceptionComponent } from './summary/underwriting-exception/underwriting-exception.component';
import { IframeViewComponent } from '@lmc-app/summary/iframe-view/iframe-view.component';

import { PromiseToPayListComponent } from '@lmc-app/loan-servicing/promise-to-pay/list/promise-to-pay-list.component';
import { FundingListComponent } from '@lmc-app/loan-servicing/funding-list/funding-list.component';
import { FundingListMomComponent } from '@lmc-app/loan-servicing/funding-list-mom/funding-list-mom.component';
// Finance Components
import { AccountInformationComponent } from './loan-servicing/reports/account-information/account-information.component';
import { PaymentBreakdownBoardComponent } from './loan-servicing/reports/payment-breakdown-board/payment-breakdown-board.component';
import { SanityChecksComponent } from './loan-servicing/reports/sanity-checks/sanity-checks.component';
import { AchChecksComponent } from './loan-servicing/reports/sanity-checks/ach-checks/ach-checks.component';
import { AchValidationComponent } from './loan-servicing/reports/sanity-checks/ach-validation/ach-validation.component';
import { BalloonPaymentsComponent } from './loan-servicing/reports/sanity-checks/balloon-payments/balloon-payments.component';
import { DailyReconComponent } from './loan-servicing/reports/sanity-checks/daily-recon/daily-recon.component';
import { MultipleStatusCodeComponent } from './loan-servicing/reports/sanity-checks/multiple-status-code/multiple-status-code.component';
import { ExpiredAchComponent } from './loan-servicing/reports/sanity-checks/expired-ach/expired-ach.component';
import { ZeroBalanceComponent } from './loan-servicing/reports/sanity-checks/zero-balance/zero-balance.component';
import { LppReportsComponent } from './loan-servicing/reports/lpp-reports/lpp-reports.component';
import { CollectionsComponent } from './Dashboard/NLS/collections/collections.component';

// Reports
import { PtpDateReportComponent } from './general-reports/ptp-date-report/ptp-date-report.component';

// Admin Settings
import { AdminSettingsComponent } from './admin-settings/admin-settings.component';
import { AssignCollectorsComponent } from './admin-settings/assign-collectors/assign-collectors.component';
import { LockedAccountsComponent } from './admin-settings/locked-accounts/locked-accounts.component';
import { ReportQueueComponent } from './loan-servicing/report-queue/report-queue.component';
import { DebuggingComponent } from './admin-settings/debugging/debugging.component';
import { PaymentProcessingComponent } from './admin-settings/payment-processing/payment-processing.component';
import { LoanServicingSettingsComponent } from './loan-servicing/loan-servicing-settings/loan-servicing-settings.component';
import { FifBranchComponent } from './loan-servicing/loan-servicing-settings/fif-branch/fif-branch.component';
import { NlsCustomerValidationComponent } from './loan-servicing/loan-servicing-settings/nls-customer-validation/nls-customer-validation.component';
import { PaymentErrorsComponent } from './loan-servicing/loan-servicing-settings/payment-errors/payment-errors.component';

// Betty
import { LoanValidationComponent } from './betty/loan-validation/loan-validation.component';

// NLS
import { InsuranceTransCancellationComponent } from './loan-servicing/insurance-trans-cancellation/insurance-trans-cancellation.component';
import { TransactionListComponent } from './loan-servicing/payment-processing/list/transaction-list.component';
import { TransactionBatchComponent } from '@lmc-app/loan-servicing/payment-processing/detail/transaction-batch.component';

//Rapid Program
import { RapidProgramComponent } from './betty/rapid-program/rapid-program.component';
import { TransunionConsentFormComponent } from './betty/transunion-consent-form/transunion-consent-form.component';

import { OldLoanCalculatorComponent } from './summary/old-loan-calculator/old-loan-calculator.component';

import { RapidFilesComponent } from './Dashboard/ZOHO/rapid-files/rapid-files.component';
import { AppsConversionComponent } from './Dashboard/apps-conversion/apps-conversion.component';
import { FundingListDashboardComponent } from './Dashboard/funding-list-dashboard/funding-list-dashboard.component';
import { MyFundedDealsDashboardComponent } from './Dashboard/my-funded-deals-dashboard/my-funded-deals-dashboard.component';
import { LoanStagingComponent } from './Dashboard/NLS/admin-reports/loan-staging/loan-staging.component';
import { AccruedInterestComponent } from './Dashboard/NLS/admin-reports/accrued-interest/accrued-interest.component';
import { LoanGroupTransferAccruedComponent } from './Dashboard/NLS/admin-reports/loan-group-transfer-accrued/loan-group-transfer-accrued.component';
import { LoanMovementComponent } from './Dashboard/NLS/admin-reports/loan-movement/loan-movement.component';
import { AdminReportLoansComponent } from './Dashboard/NLS/admin-reports/loans/admin-report-loans.component';
import { AccountSettingsComponent } from './admin-settings/account-settings/account-settings.component';
import { SahaExceptionComponent } from './Dashboard/NLS/reports/saha-exception/saha-exception.component';
import { FundingExceptionComponent } from './Dashboard/NLS/reports/funding-exception/funding-exception.component';
import { PandadocComponent } from './summary/fulfillment/pandadoc/pandadoc.component';
import { ApplicationsComponent } from './applications/applications.component';
import { ApplicationCallsComponent } from '@lmc-app/Dashboard/application-calls/application-calls.component';
import { CreateAccountComponent } from '@lmc-app/admin-settings/account/create-account/create-account.component';
import { AccountsComponent } from '@lmc-app/admin-settings/account/accounts.component';
import { UpdateAccountComponent } from '@lmc-app/admin-settings/account/update-account/update-account.component';
import { DesignSystemComponent } from './design-system/design-system.component';
import { ExternalApiClientsComponent } from './admin-settings/external-api-clients/external-api-clients.component';
import { NlsportfoliocollectionsbreakdownComponent } from '@lmc-app/Dashboard/NLS/collections/grouped/nlsportfoliocollectionsbreakdown/nlsportfoliocollectionsbreakdown.component';
import { NlsSettingsComponent } from './loan-servicing/nls-settings/nls-settings.component';
import { DocusignComponent } from './summary/docusign/docusign.component';
import { versionCheckGuard } from '@lmc-app/core/services/version-check.guard';
import { ECLConfigComponent } from '@lmc-app/admin-settings/ecl-config/ecl-config.component';
import { ECLSqlConfigComponent } from './admin-settings/ecl-sql-config/ecl-sql-config.component';
import { CreatePaymentReceiptComponent } from './loan-servicing/payment-receipts/create-payment-receipt/create-payment-receipt.component';
import { AgreementSettingsComponent } from './admin-settings/agreement-settings/agreement-settings.component';
import { AppsConversionSettingsComponent } from './admin-settings/apps-conversion-settings/apps-conversion-settings.component';
import { PromiseToPaySettingsComponent } from './admin-settings/promise-to-pay-settings/promise-to-pay-settings.component';
import { ApplicationPermissionSettingsComponent } from './admin-settings/application-permission-settings/application-permission-settings.component';

type PathMatch = 'full' | 'prefix' | undefined;

export const routes: Routes = [
	{
		// Outer wrapper: version check fires on every route navigation (all routes)
		path: '',
		canActivateChild: [versionCheckGuard],
		children: [
			{
				path: 'login',
				canActivate: [unauthGuard],
				component: LoginComponent,
				data: { title: 'Login', breadcrumb: 'readForm' },
			},
			{
				path: '',
				canActivateChild: [authGuard],
				children: [
					{
						path: '',
						component: HomeComponent,
						pathMatch: 'full' as PathMatch,
					},
					{
						path: 'transunion',
						component: TransunionComponent,
						data: { title: 'TransUnion', breadcrumb: 'TransUnion' },
					},
					{
						path: 'underwriting',
						component: UnderwritingComponent,
						data: { title: 'Underwriting', breadcrumb: 'Underwriting' },
					},
					{
						path: 'viewUnderwriting',
						component: ViewUnderwritingComponent,
						data: {
							title: 'Viewunderwriting',
							breadcrumb: 'Underwriting View',
						},
					},
					{
						path: 'preapproval',
						component: RapidProgramComponent,
						data: { title: 'Pre-Approval', breadcrumb: 'Pre-Approval' },
					},
					{
						path: 'dashboard',
						component: HomeComponent,
						data: { title: 'Home Page', breadcrumb: 'EditForm' },
					},
					{
						path: 'applications-old',
						component: ReadComponent,
						data: {
							title: 'Read application form TEST',
							breadcrumb: 'readForm',
						},
					},
					{
						path: 'applications/create-old',
						component: ApplicationComponent,
						data: {
							title: 'Create client form TEST',
							breadcrumb: 'createForm',
						},
					},
					{
						path: 'applications/edit/:id',
						component: ApplicationComponent,
						data: { title: 'Edit Form', breadcrumb: 'EditForm' },
					},
					{
						path: 'applications/clone/:id',
						component: ApplicationComponent,
						data: { title: 'Edit Form', breadcrumb: 'EditForm' },
					},
					{
						path: 'applications/summary/:id',
						component: SummaryComponent,
						children: [
							{
								path: '',
								redirectTo: '',
								pathMatch: 'full' as PathMatch,
							},
							{
								path: 'iframe-view',
								component: IframeViewComponent,
							},
							{
								path: 'pandadocs',
								component: PandadocComponent,
							},
							{
								path: 'checklist',
								component: ChecklistComponent,
							},
							{
								path: 'underwriting',
								component: UnderwritingComponent,
							},
							{
								path: 'calculator',
								component: LoancalculatorComponent,
								data: {
									title: 'Loan Calculator',
									breadcrumb: 'Loan Calculator',
								},
							},
							{
								path: 'transunion',
								component: TransunionComponent,
								data: { title: 'TransUnion', breadcrumb: 'TransUnion' },
							},
							{
								path: 'loaninterview',
								component: LoanInterviewComponent,
								data: { title: 'ZOHO', breadcrumb: 'readForm' },
							},
							{
								path: 'underwriting-exception',
								component: UnderwritingExceptionComponent,
								data: {
									title: 'Underwriting Dashboard',
									breadcrumb: 'readForm',
								},
							},
							{
								path: 'oldCalculator',
								component: OldLoanCalculatorComponent,
								data: {
									title: 'Loan Calculator',
									breadcrumb: 'Loan Calculator',
								},
							},
						],
					},
					{
						path: 'underwritingdashboard',
						component: UnderwritingdashboardComponent,
						data: { title: 'Underwriting Dashboard', breadcrumb: 'readForm' },
					},
					{
						path: 'underwritingagencyexception',
						component: UnderwritingagencyexceptionComponent,
						data: { title: 'Underwriting Dashboard', breadcrumb: 'readForm' },
					},
					{
						path: 'nlsdashboard',
						component: NlsdashboardComponent,
						data: { title: 'NLS Dashboard', breadcrumb: 'readForm' },
					},
					{
						path: 'nlsagencyfunded',
						component: NlsagencyfundedComponent,
						data: { title: 'NLS Dashboard', breadcrumb: 'readForm' },
					},
					{
						path: 'nlsagencycollectors',
						component: NlsagencycollectorsComponent,
						data: { title: 'NLS Dashboard', breadcrumb: 'readForm' },
					},
					{
						path: 'nlsagencycollections',
						component: NlsagencycollectionsComponent,
						data: { title: 'NLS Dashboard', breadcrumb: 'readForm' },
					},
					{
						path: 'nlsagencycollectionscollectors',
						component: NlsagencycollectionscollectorComponent,
						data: { title: 'NLS Dashboard', breadcrumb: 'readForm' },
					},
					{
						path: 'nlsagencycollectionscollectorclients',
						component: NlsagencycollectionscollectorclientsComponent,
						data: { title: 'NLS Dashboard', breadcrumb: 'readForm' },
					},
					{
						path: 'nlscreditorcollectionscollectors',
						component: NlscreditorcollectionscollectorComponent,
						data: { title: 'NLS Collection Report', breadcrumb: 'readForm' },
					},
					{
						path: 'nlscreditorcollections',
						component: NlscreditorcollectionsComponent,
						data: { title: 'NLS Collection Report', breadcrumb: 'readForm' },
					},
					{
						path: 'nlsportfoliodetails',
						component: NlsportfoliocollectionsbreakdownComponent,
						data: { title: 'NLS Collection Report', breadcrumb: 'readForm' },
					},
					{
						path: 'design-system',
						component: DesignSystemComponent,
						data: {
							title: 'LMC Design Guideline',
							breadcrumb: 'LMC Design Guideline',
						},
					},
					{
						path: 'interviewer',
						component: InterviewerqueueComponent,
						data: { title: 'ZOHO', breadcrumb: 'readForm' },
					},
					{
						path: 'validator',
						component: ValidatorqueueComponent,
						data: { title: 'ZOHO', breadcrumb: 'readForm' },
					},
					{
						path: 'loaninterview',
						component: LoanInterviewComponent,
						data: { title: 'ZOHO', breadcrumb: 'readForm' },
					},
					{
						path: 'incomecalculator',
						component: MonthlyincomecalcComponent,
					},
					{
						path: 'checklist',
						component: ChecklistComponent,
					},
					{
						path: 'loan-meta',
						component: LoanMetaComponent,
					},
					{
						path: 'reports',
						component: ReportsComponent,
						children: [
							{
								path: '',
								redirectTo: 'saha-exception',
								pathMatch: 'full' as PathMatch,
							},
							{
								path: 'saha-exception',
								component: SahaExceptionComponent,
							},
							{
								path: 'funding-exception',
								component: FundingExceptionComponent,
							},
						],
					},
					{
						path: 'admin-reports',
						children: [
							{
								path: 'loan-staging',
								component: LoanStagingComponent,
							},
							{
								path: 'accrued-interest',
								component: AccruedInterestComponent,
							},
							{
								path: 'loan-group-transfer-accrued',
								component: LoanGroupTransferAccruedComponent,
							},
							{
								path: 'loan-movement',
								component: LoanMovementComponent,
							},
							{
								path: 'loans/:input_date/:stage/:risk',
								component: AdminReportLoansComponent,
							},
						],
					},
					{
						path: 'promise-to-pay',
						component: PromiseToPayListComponent,
					},
					{
						path: 'funding-list',
						component: FundingListComponent,
					},
					{
						path: 'funding-list-mom',
						component: FundingListMomComponent,
					},
					{
						path: 'report-queue',
						component: ReportQueueComponent,
					},
					{
						path: 'ptp-report',
						component: PtpReportComponent,
					},
					{
						path: 'ptp-created-report',
						component: PtpCreatedReportComponent,
					},
					{
						path: 'uw-performance',
						component: UwPerformanceComponent,
					},
					{
						path: 'tv-intermedia-calls',
						component: IntermediaCallReportsComponent,
					},
					{
						path: 'call-logs',
						component: IntermediaCallReportsComponent,
					},
					{
						path: 'collection-list',
						component: CollectionsComponent,
					},
					{
						path: 'tv-collection-reports',
						component: CollectionTvReportComponent,
					},
					{
						path: 'tv-funded-reports',
						component: FundedTvReportComponent,
					},
					// Finance routes
					{
						path: 'loan-servicing/reports/account-informations',
						component: AccountInformationComponent,
					},
					{
						path: 'loan-servicing/reports/payment-breakdowns',
						component: PaymentBreakdownBoardComponent,
					},
					{
						path: 'loan-servicing/reports/sanity-checks',
						component: SanityChecksComponent,
						children: [
							{
								path: '',
								redirectTo: 'ach-checks',
								pathMatch: 'full' as PathMatch,
							},
							{
								path: 'ach-checks',
								component: AchChecksComponent,
							},
							{
								path: 'ach-validation',
								component: AchValidationComponent,
							},
							{
								path: 'balloon-payments',
								component: BalloonPaymentsComponent,
							},
							{
								path: 'daily-recon',
								component: DailyReconComponent,
							},
							{
								path: 'multiple-status-code',
								component: MultipleStatusCodeComponent,
							},
							{
								path: 'expired-ach',
								component: ExpiredAchComponent,
							},
							{
								path: 'zero-balance',
								component: ZeroBalanceComponent,
							},
						],
					},
					{
						path: 'loan-servicing/reports/lpp-reports',
						component: LppReportsComponent,
					},
					{
						path: 'reports/collections/payments-received',
						component: PtpDateReportComponent,
					},
					{
						path: 'admin-settings',
						component: AdminSettingsComponent,
						children: [
							{
								path: '',
								redirectTo: 'admin-dashboard',
								pathMatch: 'full' as PathMatch,
							},
							{
								path: 'admin-dashboard',
								component: AssignCollectorsComponent,
							},
							{
								path: 'locked-accounts',
								component: LockedAccountsComponent,
							},
							{
								path: 'account',
								children: [
									{
										path: '',
										component: AccountsComponent,
									},
									{
										path: 'create',
										component: CreateAccountComponent,
									},
									{
										path: 'update/:employee_id',
										component: UpdateAccountComponent,
									},
								],
							},
							{
								path: 'external-client-api',
								component: ExternalApiClientsComponent,
							},
							{
								path: 'ecl-config',
								component: ECLConfigComponent,
							},
							{
								path: 'ecl-sql-config',
								component: ECLSqlConfigComponent,
							},
							{
								path: 'debugging',
								component: DebuggingComponent,
							},
							{
								path: 'payment-processing',
								component: PaymentProcessingComponent,
							},
							{
								path: 'agreements',
								component: AgreementSettingsComponent,
							},
							{
								path: 'apps-conversion',
								component: AppsConversionSettingsComponent,
							},
							{
								path: 'promise-to-pay',
								component: PromiseToPaySettingsComponent,
							},
							{
								path: 'application-permissions',
								component: ApplicationPermissionSettingsComponent,
							},
						],
					},
					{
						path: 'loan-servicing/settings',
						component: LoanServicingSettingsComponent,
						children: [
							{
								path: '',
								redirectTo: 'fif-branch',
								pathMatch: 'full' as PathMatch,
							},
							{
								path: 'fif-branch',
								component: FifBranchComponent,
							},
							{
								path: 'nls-customer-validation',
								component: NlsCustomerValidationComponent,
							},
							{
								path: 'payment-errors',
								component: PaymentErrorsComponent,
							},
						],
					},
					{
						path: 'loan-validation',
						component: LoanValidationComponent,
					},
					{
						path: 'loan-servicing/insurance-cancellaction',
						component: InsuranceTransCancellationComponent,
					},
					{
						// The list is the parent, and the batch page is its child rather than its
						// sibling: it renders into the list's own <router-outlet>, so the list is
						// never destroyed and keeps its filters, page and scroll offset while a
						// batch is open. The batch page's own back button navigates back up.
						path: 'loan-servicing/payment-processing',
						component: TransactionListComponent,
						data: {
							title: 'Payment Processing',
							breadcrumb: 'Payment Processing',
						},
						children: [
							{
								path: ':batchId',
								component: TransactionBatchComponent,
								data: { title: 'Batch Details' },
							},
						],
					},
					{
						path: 'loan-servicing/payment-receipts/create',
						component: CreatePaymentReceiptComponent,
						data: {
							title: 'Create Payment Receipt',
							breadcrumb: 'Create Payment Receipt',
						},
					},
					{
						path: 'transunion-consent-form',
						component: TransunionConsentFormComponent,
						data: { title: 'Consent to Pull Credit', breadcrumb: 'LMCredit' },
					},
					{
						path: 'rapid-files',
						component: RapidFilesComponent,
					},
					{
						path: 'applications',
						children: [
							{
								path: '',
								component: ApplicationsComponent,
							},
							{
								path: 'calls',
								redirectTo: '/dashboard/calls',	// new url
								pathMatch: 'full' as PathMatch,
							},
							{
								path: ':id',
								component: SummaryComponent,
							},
						],
					},
					{
						path: 'dashboard',
						children: [
							{
								path: 'apps-conversion',
								component: AppsConversionComponent,
							},
							{
								path: 'funding-list',
								component: FundingListDashboardComponent,
							},
							{
								path: 'my-funded-deals',
								component: MyFundedDealsDashboardComponent,
							},
							{
								path: 'uw-daily-stat',
								component: UwDailyStatComponent,
							},
							{
								path: 'calls',
								component: ApplicationCallsComponent,
							},
						],
					},
					{
						path: 'loan-servicing/nls-setting',
						component: NlsSettingsComponent,
					},
					{
						path: 'user-contacts',
						component: AccountSettingsComponent,
					},
					{
						path: 'envelope-preview',
						component: DocusignComponent,
					},
				],
			},
			{ path: '**', redirectTo: 'login' }, // This one has to be the last
		],
	},
];
